import config from "config";
import { authHeader, handleResponse } from "../_helpers";

function getIframeSettings() 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/iframeSettings`, requestOptions).then(response =>
        handleResponse(response, false, false)
    );
}

function updateIframeSettings(newSettings)
{
    debugger;
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(newSettings ? newSettings : {} )
    };
    return fetch(`${config.apiUrl}/Settings/iframeSettingsUpdate`, requestOptions).then(
        handleResponse
    );
}

function deleteIframeSettings(newSettings)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(newSettings ? newSettings : {} )
    };
    return fetch(`${config.apiUrl}/Settings/iframeSettingsDelete`, requestOptions).then(
        handleResponse
    );
    
}

function getSubFlows() 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/Flows`, requestOptions).then(response =>
        handleResponse(response, false, false)
    );
}

function getAnchorElementTypes() 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/AnchorElementTypes`, requestOptions).then(response =>
        handleResponse(response, false, false)
    );
}

function getAnchorElementPositions() 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/AnchorElementPositions`, requestOptions).then(response =>
        handleResponse(response, false, false)
    );
}

function getExcludedStates() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" }
  };

  return fetch(`${config.apiUrl}/lookup/states`, requestOptions).then(
    handleResponse
  );
}

function getOptionSettings() 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/optionSettings`, requestOptions).then(response =>
        handleResponse(response, false, false)
    );
}

function addOption(newOption)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(newOption ? newOption : {} )
    };
    return fetch(`${config.apiUrl}/Settings/optionSettingsAdd`, requestOptions).then(
        handleResponse
    );
}

function deleteOption(newOption)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(newOption ? newOption : {} )
    };
    return fetch(`${config.apiUrl}/Settings/optionSettingsDelete`, requestOptions).then(
        handleResponse
    );
}

//profile
function getProfileSettings()
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({})
    };
    return fetch(`${config.apiUrl}/Settings/profile/get`, requestOptions).then(
        handleResponse
    );
}

function updateProfileSettings(settings)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(settings ? settings : {})
    };
    return fetch(`${config.apiUrl}/Settings/profile/update`, requestOptions).then(
        handleResponse
    );
}

function addBigCommerce(settings)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(settings)
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/add`, requestOptions).then(
        handleResponse
    );
}

function deleteBigCommerce(settings)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(settings)
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/delete`, requestOptions).then(
        handleResponse
    );
}

function updateBigCommerce(settings)
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(settings ? settings : {} )
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/update`, requestOptions).then(
        handleResponse
    );
}



function getAllBigCommerce()
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({})
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/getall`, requestOptions).then(
        handleResponse
    );
}

function getBigCommerceChannels(hash, token)
{
    const requestOptions = {
        method: "GET",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/channels?hash=${encodeURIComponent(hash)}&token=${encodeURIComponent(token)}`, requestOptions).then(
        handleResponse
    );
}

function getBigCommerceCustomerGroups(hash, token)
{
    const requestOptions = {
        method: "GET",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl}/Settings/bigCommerce/customerGroups?hash=${encodeURIComponent(hash)}&token=${encodeURIComponent(token)}`, requestOptions).then(
        handleResponse
    );
}

function getIframeSettingsByURL(url) 
{
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(url ? url : {} )
    };
    return fetch(`${config.apiUrl}/Settings/iframeSettingsByUrl`, requestOptions).then(
        handleResponse
    );
}

function getScript(data)
{
    const requestOptions = {
        method: "GET",
        headers: { ...authHeader(), "Content-Type": "application/json" },
    };
    return fetch(`${config.apiUrl.slice(0,-4)}/badge/generate?referrer=${data.referrer}&theme=${data.theme}`, requestOptions).then(
        handleResponse
    );
}

export const settingsService =
{
    getIframeSettings,
    updateIframeSettings,
    deleteIframeSettings,
    getSubFlows,
    getOptionSettings,
    addOption,
    deleteOption,
    addBigCommerce,
    deleteBigCommerce,
    updateBigCommerce,
    getAllBigCommerce,
    getBigCommerceChannels,
    getBigCommerceCustomerGroups,
    getIframeSettingsByURL,
    getProfileSettings,
    updateProfileSettings,
    getAnchorElementTypes,
    getAnchorElementPositions,
    getExcludedStates,
    getScript

};